import clsx from "clsx";
import { motion } from "framer-motion";
import styles from "./Footer.module.scss";
import { isEmpty } from "lodash";

type MediaListWrapperProps = {
  mediaList: any[];
};

const MediaListWrapper = ({ mediaList }: MediaListWrapperProps) => {
  const gridColumns = {
    desktop: Math.min(8, mediaList.length),
    tablet: Math.min(4, mediaList.length),
    mobile: Math.min(2, mediaList.length),
  };

  if (isEmpty(mediaList)) return null;

  return (
    <div
      className={styles.mediaListWrapper}
      style={
        {
          "--desktop-grid-columns": gridColumns.desktop,
          "--tablet-grid-columns": gridColumns.tablet,
          "--mobile-grid-columns": gridColumns.mobile,
        } as React.CSSProperties
      }
    >
      {mediaList.map((data: any, idx: number) => {
        return (
          <a
            key={idx}
            href={data?.Link}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.imageWrapper}
          >
            <motion.img
              src={data?.mediaFileblackandwhite?.data?.attributes?.url}
              className={clsx(styles.image, styles.image1)}
            />
            <motion.img
              src={data?.mediaFileColour?.data?.attributes?.url}
              className={clsx(styles.image, styles.image2)}
            />
          </a>
        );
      })}
    </div>
  );
};

export default MediaListWrapper;
